import { IMAGES, WA_MESSAGES } from "@/config/business";
import { WhatsAppButton } from "./CtaButtons";

const Gallery = () => (
  <section id="gallery" className="scroll-mt-24 bg-[#F4EFEA] py-16 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#9E7B36]">
          The Experience
        </p>
        <h2 className="mt-3 font-serif text-3xl font-medium tracking-tight text-[#1C1917] sm:text-4xl">
          Your Time to Unwind
        </h2>
        <p className="mt-4 text-sm text-[#57534E] sm:text-base">
          Step away from the everyday and enjoy a calm wellness experience at GK Wellness &amp;
          Luxury Spa.
        </p>
      </div>
      <div
        data-testid="gallery-grid-container"
        className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-4"
      >
        {IMAGES.gallery.map((image, index) => (
          <figure
            key={image.caption}
            className={`group relative overflow-hidden rounded-2xl ${
              index === 0 ? "col-span-2 row-span-2" : ""
            }`}
          >
            <img
              src={image.src}
              alt={image.alt}
              loading="lazy"
              decoding="async"
              className={`w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
                index === 0 ? "aspect-[4/3] lg:h-full" : "aspect-square"
              }`}
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#1C1917]/80 to-transparent px-4 pb-3 pt-10 text-xs font-semibold text-white sm:text-sm">
              {image.caption}
            </figcaption>
          </figure>
        ))}
      </div>
      <div className="mt-10 text-center">
        <WhatsAppButton
          message={WA_MESSAGES.general}
          label="Book Your Experience"
          testId="gallery-whatsapp-cta"
        />
      </div>
    </div>
  </section>
);

export default Gallery;
